import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import tippy from 'tippy.js';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var getNativeTippyProps = function getNativeTippyProps(props) {
  var children = props.children,
      onCreate = props.onCreate,
      tippyProps = objectWithoutProperties(props, ['children', 'onCreate']);

  return tippyProps;
};

var Tippy = function (_React$Component) {
  inherits(Tippy, _React$Component);

  function Tippy() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Tippy);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Tippy.__proto__ || Object.getPrototypeOf(Tippy)).call.apply(_ref, [this].concat(args))), _this), _this.content = React.createRef(), _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Tippy, [{
    key: 'getContent',
    value: function getContent() {
      return React.isValidElement(this.props.content) ? this.content.current : this.props.content;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.tip = tippy.one(ReactDOM.findDOMNode(this), _extends({}, getNativeTippyProps(this.props), {
        content: this.getContent()
      }));
      this.props.onCreate && this.props.onCreate(this.tip);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.tip.set(_extends({}, getNativeTippyProps(this.props), {
        content: this.getContent()
      }));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.tip) {
        this.tip.destroy();
        this.tip = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        React.Fragment,
        null,
        this.props.children,
        React.isValidElement(this.props.content) && React.createElement(
          'div',
          { ref: this.content },
          this.props.content
        )
      );
    }
  }]);
  return Tippy;
}(React.Component);

Tippy.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  children: PropTypes.element.isRequired
};

export default Tippy;
//# sourceMappingURL=Tippy.js.map
